module.exports = __webpack_public_path__ + "img/coupon2.b952b0ab.png";